import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ListsIcon } from 'foundations-assets/icons/components/ListsIcon';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { Fragment } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SelectedTeamOptionParentList = ({
  name,
  fullParentNameList
}) => {
  if (fullParentNameList.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "100",
    children: [fullParentNameList.map(parentName => /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(Small, {
        color: "text-core-subtle",
        children: parentName
      }), /*#__PURE__*/_jsx(RightIcon, {
        color: "text-core-disabled",
        alignWithText: true,
        size: "100"
      })]
    }, parentName)), /*#__PURE__*/_jsx(Small, {
      color: "text-core-subtle",
      children: name
    })]
  });
};
const SelectedTeamOption = ({
  id,
  name,
  totalTeamMembers,
  fullParentNameList,
  onRemoveTeam,
  userCanRemoveTeam
}) => {
  return /*#__PURE__*/_jsxs(MultiColumnGroup, {
    children: [/*#__PURE__*/_jsx(MultiColumnItem, {
      paddingInlineEnd: "0",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(ListsIcon, {
          size: "600"
        }), /*#__PURE__*/_jsxs(View, {
          as: "div",
          marginInlineStart: "600",
          children: [/*#__PURE__*/_jsxs(Flex, {
            flexDirection: "row",
            alignItems: "center",
            gap: "200",
            children: [/*#__PURE__*/_jsx(View, {
              as: "div",
              children: name
            }), /*#__PURE__*/_jsx(Small, {
              color: "text-core-subtle",
              children: totalTeamMembers === 1 ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: "ui-asset-management-lib.assetAccessPanel.singularMember"
              }) : /*#__PURE__*/_jsx(FormattedMessage, {
                message: "ui-asset-management-lib.assetAccessPanel.pluralMembers",
                options: {
                  totalTeamMembers
                }
              })
            })]
          }), /*#__PURE__*/_jsx(SelectedTeamOptionParentList, {
            name: name,
            fullParentNameList: fullParentNameList
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(MultiColumnItem, {
      children: userCanRemoveTeam && /*#__PURE__*/_jsx(IconButton, {
        "data-test-id": `remove-team-button-${id}`,
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-asset-management-lib.tooltips.removeTeam"
        }),
        size: "extra-small",
        use: "transparent",
        onClick: () => onRemoveTeam(id),
        children: /*#__PURE__*/_jsx(RemoveIcon, {})
      })
    })]
  });
};
export default SelectedTeamOption;